export default __webpack_public_path__ + "static/media/review8.007335be.jpg";